import { compact, isEmpty, orderBy } from 'lodash-es';

import { Address, AddressType, LinxFormAddressModel } from '@shared/models';

export const formAddressSerializer = (address: LinxFormAddressModel): Address | undefined => {
  if (isEmpty(address) || !address?.addressLine1 || !address?.country || !address?.city || !address?.state) return undefined;

  const {
    id,
    contactFirstName,
    contactMiddleName,
    contactLastName,
    type,
    addressLine1,
    addressLine2,
    postalCode,
    country,
    city,
    state,
    primary,
  } = address;

  return {
    contactFirstName,
    contactMiddleName,
    contactLastName,
    id: id,
    streetLine1: addressLine1,
    streetLine2: addressLine2,
    zipCode: postalCode,
    cityName: city,
    stateCode: state,
    countryCode: country,
    primary: !!primary,
    type,
  };
};

export const formAddressDeserializer = (address: Address): LinxFormAddressModel | undefined => {
  if (isEmpty(address) || !address?.streetLine1 || !address?.countryCode || !address?.cityName || !address?.stateCode) return undefined;

  const {
    id,
    streetLine1,
    streetLine2,
    zipCode,
    cityName,
    stateCode,
    countryCode,
    primary,
    type,
    verified,
    contactFirstName,
    contactMiddleName,
    contactLastName,
  } = address;

  return {
    id,
    contactFirstName,
    contactMiddleName,
    contactLastName,
    addressLine1: streetLine1,
    addressLine2: streetLine2 ?? undefined,
    postalCode: zipCode ?? '',
    city: cityName,
    state: stateCode,
    country: countryCode,
    type,
    primary,
    verified,
  };
};

export const getAddressesOfType = (addresses: Address[], addressType: AddressType): LinxFormAddressModel[] => {
  return orderBy(
    compact(addresses.filter(({ type }) => type === addressType).map((address) => formAddressDeserializer(address))),
    ['primary'],
    ['desc'],
  );
};
